import { useCallback } from "react"
import {
  Block,
  Button,
  Discord,
  useStyletron,
  Wallet04,
} from "@mezo-org/mezo-clay"

import { setOnboardingFlow, useDappDispatch } from "#/redux-state"
import { ENABLE_DISCORD_ONBOARDING } from "#/shared/constants"
import { OnboardingFlow } from "#/shared/types"

import OnboardingModalContent from "./OnboardingModalContent"
import OnboardingModalFooter from "./OnboardingModalFooter"

type OnboardingModalAuthenticationProps = {
  connectWalletHandler: () => void
}

export default function OnboardingModalAuthentication({
  connectWalletHandler,
}: OnboardingModalAuthenticationProps) {
  const dispatch = useDappDispatch()
  const [css, theme] = useStyletron()

  // TODO: Implement discord integration
  const connectDiscordHandler = useCallback(() => {}, [])

  const signInWithWalletHandler = useCallback(() => {
    dispatch(setOnboardingFlow(OnboardingFlow.SIGN_IN))
    connectWalletHandler()
  }, [dispatch, connectWalletHandler])

  return (
    <OnboardingModalContent
      header="Sign in"
      footer={<OnboardingModalFooter onSignUp={connectWalletHandler} />}
    >
      <Block className={css({ paddingTop: theme.sizing.scale1000 })}>
        <Block
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: theme.sizing.scale300,
          })}
        >
          {ENABLE_DISCORD_ONBOARDING && (
            <Button
              id="passport-sign_in_with_discord"
              onClick={connectDiscordHandler}
              kind="secondary"
              width="100%"
              startEnhancer={<Discord size={24} color={theme.colors.black} />}
            >
              Sign in with Discord
            </Button>
          )}
          <Button
            id="passport-sign_in_with_wallet"
            onClick={signInWithWalletHandler}
            kind="secondary"
            width="100%"
            startEnhancer={
              <Wallet04
                size={24}
                color={theme.colors.black}
                overrides={{
                  Svg: { style: () => ({ fill: theme.colors.black }) },
                }}
              />
            }
          >
            Sign in with Wallet
          </Button>
        </Block>
      </Block>
    </OnboardingModalContent>
  )
}
